import { useEffect, useMemo, useRef, useState } from "react";
import CardsContainer from './CardsContainer';
import { useNotifyContext } from "./hooks";
import { iconMap } from "./config";
import { CloseIcon } from "./imgs/Close";
import { Button, Carousel } from "antd";
import Card from "./Card";
import cs from './index.module.scss';
import cx from 'classnames';

export const autoSpotNotifyLocalKey = 'autoSpotNotifyLocal';
export const autoThanosNotifyLocalKey = 'autoThanosNotifyLocal';
const AUTO_SHOW_TIME = 15 * 1000;
const AUTO_MAX_LEN = 5;

export const AutoNoti = () => {
  const timeRef = useRef(-1);
  const playtimeRef = useRef(-1);
  const carouselRef = useRef(null);

  const { t, isSpot, context, setContext, noticeList } = useNotifyContext();
  const [currentNoticeIdx, setCurrentNoticeIdx] = useState(-1);
  
  const autoNotifyLocalKey = useMemo(() => {
    return isSpot ? autoSpotNotifyLocalKey : autoThanosNotifyLocalKey;
  }, [isSpot]);

  const [notices, hasDots] = useMemo(() => {
    if (!noticeList.length) {
      return [[], false];
    }
    if (typeof window != 'undefined') {
      const config = localStorage.getItem(autoNotifyLocalKey);
      if (config) {
        const { time } = JSON.parse(config);
        const needPushList = noticeList.filter(item => item.createTime >= time);
        const list = needPushList.slice(0, AUTO_MAX_LEN);
  
        return [list, list.length > 1];
      }
    }
    const list = noticeList.slice(0, AUTO_MAX_LEN);

    return [list, list.length > 1];
  }, [noticeList]);

  const currentNotice = useMemo(() => {
    return currentNoticeIdx != -1 ? notices[currentNoticeIdx] : null;
  }, [currentNoticeIdx, notices]);
  

  const typeConfig = useMemo(() => {
    return currentNotice ? iconMap[currentNotice.type] : null;
  }, [currentNotice]);

  useEffect(() => {
    if (currentNoticeIdx == -1 && notices.length) {
      setContext({
        autoNotiOpen: true,
      });
      setCurrentNoticeIdx(0);
    }
  }, [currentNoticeIdx, notices.length]);

  useEffect(() => {
    if (!context.autoNotiOpen) {
      return;
    }

    if (timeRef.current != -1) {
      clearTimeout(timeRef.current);
      timeRef.current = -1;
    }

    if (context.beginCount) {
      timeRef.current = setTimeout(() => {
        setContext({
          autoNotiOpen: false,
          showAutoNotiContent: false,
        });
        localStorage.setItem(autoNotifyLocalKey, JSON.stringify({
          value: 1,
          time: Date.now(),
        }));
        clearTimeout(timeRef.current);
        timeRef.current = -1;
      }, AUTO_SHOW_TIME * notices.length);
    }
  }, [context.autoNotiOpen, context.beginCount, notices.length]);

  useEffect(() => {
    if (!context.autoNotiOpen || !hasDots) {
      return;
    }

    if (playtimeRef.current != -1) {
      clearTimeout(playtimeRef.current);
      playtimeRef.current = -1;
    }

    if (context.beginCount) {
      const nextIdx = (currentNoticeIdx + 1) % notices.length;
      playtimeRef.current = setTimeout(() => {
        onDotItemClick(nextIdx);
        clearTimeout(playtimeRef.current);
        playtimeRef.current = -1;
      }, AUTO_SHOW_TIME);
    }

  }, [context.autoNotiOpen, context.beginCount, currentNoticeIdx, notices.length, hasDots]);

  const close = () => {
    setContext({
      autoNotiOpen: false,
    });
    localStorage.setItem(autoNotifyLocalKey, JSON.stringify({
      value: 1,
      time: Date.now(),
    }));
  };

  const onDotItemClick = (idx) => {
    if (idx == currentNoticeIdx) {
      return;
    }
    setCurrentNoticeIdx(idx);
    carouselRef.current?.goTo(idx);
  };

  const onCarouselAfterChange = (idx) => {
    setCurrentNoticeIdx(idx);
  };

  const onContainerMouseLeave = () => {
    setContext({
      beginCount: true,
      showAutoNotiContent: false,
    });
  };

  const onContainerMouseEnter = () => {
    setContext({
      beginCount: false,
    });
  };

  const onReadMoreClick = () => {
    window.open(currentNotice.webClickUrl);
  };

  return (
    <>{(!context.autoNotiOpen || !currentNotice) ? null :
      <CardsContainer
        onMouseLeave={onContainerMouseLeave}
        onMouseEnter={onContainerMouseEnter}
        className={context.showAutoNotiContent ? cs.openedContainer : ''}
      >
        {typeConfig ? <header className={cs.containerHeader}>
          <typeConfig.Icon className={cs.hotIcon} />
          <span>{t(typeConfig.labelKey)}</span>
          <CloseIcon className={cs.closeIcon} onClick={close} />
        </header> : null}

        <Carousel dots={false} ref={carouselRef} afterChange={onCarouselAfterChange}>
          {notices?.map(item => <Card key={item.id} config={item} />)}
        </Carousel>

        <footer className={cs.cardFooter}>
          {hasDots ? <div className={cs.cardDots}>
            {notices?.map((item, idx) => (
              <div
                key={item.id}
                onClick={() => onDotItemClick(idx)}
                className={cx(cs.dotItem, item.id === currentNotice.id ? cs.dotItemSelected : '')}
              />
            ))}
          </div> : null}
          {(context.showAutoNotiContent && currentNotice?.webClickUrl) ? <div className={cs.operates}>
            <Button type="primary" className={cs.primaryBtn} onClick={onReadMoreClick}>
              <span>{t('acount.viewmore')}</span>
            </Button>
          </div> : null}
        </footer>
      </CardsContainer>}
    </>
  )
}